import { useContext, useEffect } from "react"
import { authContext } from '../context/auth-context'
import { Navigate, Outlet } from 'react-router-dom'
import useGetData from '../hooks/useGetData'
import classes from '../styles/Tasks.module.css'
import viewFileApi from "../services/viewFileApi"

const ViewFiles = (props) => {
    const { token, authUser } = useContext(authContext)

    const { data: viewFiles, isLoading: viewFilesLoading } = useGetData({
        queryKey: 'view-files',
        queryFn: () => viewFileApi.getViewFiles(token),
    })
    
    useEffect(() => {
        document.title = 'View Files - Analog Group'
      }, [])

    if (authUser?.user_type !== 'ADMINISTRATOR') {
        return <Navigate to='/login' />
    }

    return (
        <>
            <div className={classes.task_container}>
                <Outlet context={{viewFiles, viewFilesLoading}}/>
            </div>
        </>
    )
}

export default ViewFiles